import * as React from 'react';
import {
  FormGroup,
  FormGroupFeedback,
  Frow,
  IButtonProps,
  IFormGroupProps,
  Intent,
  ISelectOption,
  NumericButton,
} from '@pinpointhq/thumbtack';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';

interface ISelectableButtonField extends IButtonProps {
  name: string;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
  optionArray: ISelectOption[];
}

export default function SelectableButtonField<T extends string>({
  name,
  formGroupProps,
  optionArray,
  ...buttonProps
}: ISelectableButtonField) {
  const [field, meta, helpers]: [FieldInputProps<T>, FieldMetaProps<T>, FieldHelperProps<T>] = useField<T>(name);
  const hasError = meta.touched && meta.error;

  const activeItem = optionArray.find((item) => field.value && item.value === field.value);
  const handleOptionSelect = (selectedOption: ISelectOption) => {
    helpers.setValue(selectedOption.value as T);
  };

  return (
    <FormGroup {...formGroupProps} labelFor={name}>
      <Frow gutters={8}>
        {optionArray.map((option) => {
          const handleSelect = () => handleOptionSelect(option);
          return (
            <div key={option.value}>
              <NumericButton
                {...buttonProps}
                active={activeItem === option}
                text={option.label}
                onClick={handleSelect}
                outlined={true}
              />
            </div>
          );
        })}
      </Frow>
      {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
      {field.value && <input type="hidden" name={field.name} value={field.value} />}
    </FormGroup>
  );
}
